module.exports = __webpack_public_path__ + "static/media/new_logo_1.4da573d8.png";